import React from 'react';
import { RouteComponentProps } from 'react-router';

export const Page: React.FC<RouteComponentProps> = () => {
  return <div></div>;
};
